<template>
    <div class="works">
        <NavBar :white="true" />
        <WorksContent />
    </div>
</template>

<script>
    import NavBar from "../../components/NavBar";
    import WorksContent from "../../components/works/WorksContent";
    import Configuration from "../../utils/configuration";

    export default {
        name: 'Works',
        components: {
            NavBar,
            WorksContent
        },
        metaInfo: {
          title: 'オロ、グローバルチームのデジタル系プロジェクトの実績一覧です',
          meta: [
              {
                property: 'description',
                content: '限られた資源で複数国のマーケットをターゲットにするグローバルマーケティングで多くの日系企業の海外ビジネスをサポートしています。様々なタイプのプロジェクト実績をご覧いただくことができます。',
                vmid: 'description'
              },
              {
                property: 'og:title',
                content: 'オロ、グローバルチームのデジタル系プロジェクトの実績一覧です',
                vmid: 'og:title'
              },
              {
                property: 'og:url',
                content: 'https://www.oro.com/global/works/',
                vmid: 'og:url'
              },
              {
                property: 'og:type',
                content: Configuration.site.meta.og_type,
                vmid: 'og:type'
              },
              {
                property: 'og:site_name',
                content: Configuration.site.meta.og_site_name,
                vmid: 'og:site_name'
              }
          ]
        }
    }
</script>
<style lang="scss">
    .works {
        padding-top: 160px;
    }
</style>
